import { Injectable } from '@angular/core';
import { Leaflet } from '../leaflet-export';

@Injectable()
export class LeafletTopBarService {
  extends() {
    /**
     * CONTROL PLUG-IN
     */
    Leaflet.Control.TopBarControl = Leaflet.Control.extend({
      includes: Leaflet.Evented ? Leaflet.Evented.prototype : Leaflet.Mixin.Events,

      options: {
        container: null,
        position: 'topright',
      },

      onAdd: function (map) {
        const container =
          typeof this.options.container === 'string'
            ? Leaflet.DomUtil.get(this.options.container)
            : this.options.container;

        return container;
      },

      onRemove: function (map) {},
    });

    Leaflet.control.topBarControl = function (opts) {
      return new Leaflet.Control.TopBarControl(opts);
    };

    /**
     * PLUG-IN
     */

    Leaflet.TopBar = (Leaflet.Layer || Leaflet.Class).extend({
      includes: Leaflet.Evented || Leaflet.Mixin.Events,

      initialize: function (topBarOptions) {
        Leaflet.setOptions(this, topBarOptions);
      },
    });

    Leaflet.topBar = function (opts) {
      return new Leaflet.topBar(opts);
    };

    Leaflet.Map.addInitHook(function () {
      if (this.options.topBarOptions) {
        this.topBar = Leaflet.topBar(this.options.topBarOptions || {});
      }
    });
  }
}
